const getComponentText = (component) => {
  const value =
    component?.longText ??
    component?.long_name ??
    component?.longName ??
    component?.shortText ??
    component?.short_name ??
    component?.name;

  return value === undefined || value === null ? "" : String(value).trim();
};

const extractStreetAndNumber = (value) => {
  const text = String(value || "").trim();
  if (!text) return { street: "", streetNumber: "" };

  const numberAtEnd = text.match(/^(.+?)\s+(\d+[A-Za-zΑ-Ωα-ω\-\/]*)$/);
  if (numberAtEnd) {
    return {
      street: numberAtEnd[1].trim(),
      streetNumber: numberAtEnd[2].trim(),
    };
  }

  const numberAtStart = text.match(
    /^(\d+[A-Za-zΑ-Ωα-ω\-\/]*)\s+(.+)$/
  );
  if (numberAtStart) {
    return {
      street: numberAtStart[2].trim(),
      streetNumber: numberAtStart[1].trim(),
    };
  }

  return { street: text, streetNumber: "" };
};

export const parseGoogleAddress = (components = [], formattedAddress = "") => {
  let street = "";
  let streetNumber = "";
  let city = "";
  let zip = "";

  components.forEach((component) => {
    const types = component?.types || [];

    if (types.includes("route")) street = getComponentText(component);
    if (types.includes("street_number"))
      streetNumber = getComponentText(component);
    if (!city && types.includes("locality"))
      city = getComponentText(component);
    if (!city && types.includes("postal_town"))
      city = getComponentText(component);
    if (!city && types.includes("administrative_area_level_2"))
      city = getComponentText(component);
    if (types.includes("postal_code"))
      zip = getComponentText(component).replace(/\s+/g, "");
  });

  if (!streetNumber && street) {
    const splitStreet = extractStreetAndNumber(street);
    street = splitStreet.street || street;
    streetNumber = splitStreet.streetNumber;
  }

  if (!streetNumber) {
    const firstLine = String(formattedAddress || "").split(",")[0] || "";
    const splitFirstLine = extractStreetAndNumber(firstLine);
    if (!street && splitFirstLine.street) street = splitFirstLine.street;
    if (splitFirstLine.streetNumber)
      streetNumber = splitFirstLine.streetNumber;
  }

  return {
    street: street.trim(),
    streetNumber: streetNumber.trim(),
    city: city.trim(),
    zip: zip.trim(),
  };
};

export default parseGoogleAddress;
